<template>
    <div style="padding-top: 40px;">
       
       
       
        <div class="weui-form-li">
            新密码：
               <input  type="password" class="weui-form-input" v-model="firstpsd">
           </div>
           <div class="weui-form-li">
            再次输入新密码：
               <input  type="password" class="weui-form-input" v-model='secondpsd'>
           </div>

           <br>
           <a class="weui-btn  b-blue" @click="confirm">确认</a>
   
       <br>
       <br>


        </div>
    </div>
</template>

<script>
      import axios from '@/js/axios.js'
    export default {
      data(){
        return {
            firstpsd:"",
            secondpsd:"",
        }
    },
    methods:{
        confirm(){
            if(this.firstpsd&&this.secondpsd){
                }else{
                return weui.topTips('密码不能为空',3000);
                }
                if(this.firstpsd===this.secondpsd){
                   axios.post("/zzhpower/mima",{psd:this.firstpsd}).then(res=>{
                       if(res.code==200){
                           weui.alert("密码修改成功");
                       }else{
                           weui.alert("密码修改失败")
                       }
                   })

                }else{
                weui.topTips('密码不一致',3000);
                
                }
        }
    }
}
</script>

<style>
      .weui-header {
    position: relative;
    padding: 3px 0;
    -webkit-box-sizing: border-box;

  }
  .weui-header .weui-header-title,.weui-header h1 {
    margin: 0 88px;
    margin-left: 100px;
    line-height: 40px;
    text-align: center;
    height: 40px;
    font-size: 18px;
    font-weight: 400;
    width: auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #fff
  }
  .weui-header .weui-header-title a,.weui-header .weui-header-title a:active,.weui-header h1 a,.weui-header h1 a:active {
    color: #fff
  }
  .weui-header .weui-header-left,.weui-header .weui-header-right {
    position: absolute;
    top: 14px;
    display: block;
    font-size: 16px;
    line-height: 21px;
    color:#FFF;
  }
  .weui-header .weui-header-left a,.weui-header .weui-header-left button,.weui-header .weui-header-right a,.weui-header .weui-header-right button {
    float: left;
    margin-right: 8px;
  }
  .weui-header .weui-header-left a:active,.weui-header .weui-header-left button:active,.weui-header .weui-header-right a:active,.weui-header .weui-header-right button:active {
    opacity: .8
  }
  .weui-header .weui-header-left {
    left: 18px
  }
  .weui-header .weui-header-right {
    right: 15px
  }
  .weui-header .weui-header-right a,.weui-header .weui-header-right button {
    margin-left: 8px;
    margin-right: 0
  }
.bg-blue {
    background-color: #10aeff;
}
.weui-form-li{
    vertical-align: middle;
    position: relative;
    margin:10px 20px;
}
.weui-form-input,.weui-form-area{
    background-color: #fff;
    border: 1px solid #cdcdcd;
    border-radius: 1px;
    padding:5px 2px;
    line-height: 24px;
    font-size: 16px;
    width: 100%;
    outline: 0;
    -webkit-appearance: none;
    cursor: pointer;
}
.weui-btn {
  position: relative;
  display: block;
  width: 184px;
  margin-left: auto;
  margin-right: auto;
  padding: 8px 24px;
  box-sizing: border-box;
  font-weight: 700;
  font-size: 17px;
  text-align: center;
  text-decoration: none;
  color: #fff;
  line-height: 1.41176471;
  border-radius: 4px;
  overflow: hidden;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
}
.b-blue {
    color: #10aeff;
    border: 1px solid #10aeff!important;
}
</style>


// WEBPACK FOOTER //
// src/manage/Change.vue